import {
  COMPONENT_VALUE_TYPES as types, 
  COMPONENT_COLOR_THEMES,
  PERCENTAGES,
  BACKGROUND_IMAGE_POSITION,
  TWO_COLUMN_TEXT_LAYOUTS,
  COMPONENT_PARALLAX_SPEED
} from 'shared/constants';

const propsSchema = [
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'text_animation',
    label: 'Text Animation',
    type: types.BOOLEAN
  },
  {
    key: 'text_position',
    label: 'Text Position',
    type: types.ENUM,
    options: TWO_COLUMN_TEXT_LAYOUTS
  },
  {
    key: 'bg_img',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: 'desktop_img',
        label: 'Desktop Image',
        type: types.OBJECT,
        children: [
          {
            key: 'url',
            label: 'Url',
            type: types.TEXT
          },
          {
            key: 'position',
            label: 'Position',
            type: types.ENUM,
            options: BACKGROUND_IMAGE_POSITION
          },
          {
            key: 'dark_overlay',
            label: 'Dark overlay',
            type: types.ENUM,
            options: PERCENTAGES
          }
        ]
      },
      {
        key: 'mobile_img',
        label: 'Mobile Image',
        type: types.OBJECT,
        children: [
          {
            key: 'url',
            label: 'Url',
            type: types.TEXT
          },
          {
            key: 'position',
            label: 'Position',
            type: types.ENUM,
            options: BACKGROUND_IMAGE_POSITION
          },
          {
            key: 'dark_overlay',
            label: 'Dark overlay',
            type: types.ENUM,
            options: PERCENTAGES
          }
        ]
      }
    ]
  },
  {
    key: 'parallax_effect',
    label: 'Parallax Effect',
    type: types.OBJECT,
    option: false,
    children: [
      {
        key: 'enable',
        label: 'Enable',
        type: types.BOOLEAN
      },
      {
        key: 'speed',
        label: 'Speed',
        type: types.ENUM,
        options: COMPONENT_PARALLAX_SPEED
      }
    ]
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT
  },
  {
    key: 'subtitle',
    label: 'Subtitle',
    type: types.TEXT
  },
  {
    key: 'description',
    label: 'Description',
    type: types.TEXT
  },
  {
    key: 'cta',
    label: 'CTA',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT_WITH_ICON,
        children: [
          { key: 'text', label: 'Text' },
          { key: 'icon', label: 'Icon' },
          { key: 'placement', label: 'Placement' }
        ]
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'open_in_new_tab',
        label: 'Open in a new tab',
        type: types.BOOLEAN
      },
      {
        key: 'hide_for_blocked_areas',
        label: 'Hide for Blocked Areas',
        type: types.BOOLEAN
      }
    ]
  }
];

const defaultProps = {
  color_theme: 'LIGHT',
  text_animation: true,
  text_position: 'RIGHT',
  bg_img: {
    desktop_img: {
      url: 'https://genesis-cdn.ff.com/product/08_last/faraday-future-ff-91-beach-sunset-image.jpg',
      position: 'LEFT TOP',
      dark_overlay: 0
    },
    mobile_img: {
      url: 'https://genesis-cdn.ff.com/product/08_last/faraday-future-ff-91-beach-sunset-image.jpg',
      position: 'LEFT TOP',
      dark_overlay: 0
    }
  },
  parallax_effect: {
    enable: true,
    speed: 300
  },
  title: 'Your Future',
  subtitle: '',
  description: 'Help us shape the imminent future of electric mobility. Become one of the very first users of the autonomous-ready, dynamically advanced FF 91 by applying for your membership now. For questions, contact us at product@faradayfuture.com.',
  cta: {
    label: {
      text: 'preorder',
      icon: 'ff-icon-long-arrow-right',
      placement: 'AFTER'
    },
    url: '/',
    open_in_new_tab: false,
    hide_for_blocked_areas: false
  }
};

export default {
  title: 'CTA Section',
  id: 'CTASection',
  propsSchema,
  defaultProps
};
